/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-14",
    versionChannel: "nightly",
    buildDate: "2024-12-14T00:06:42.324Z",
    commitHash: "24ebd8ffaa09e36796207ef872531ac88dd3b5dd",
};
